export const MLP_PLATFORM_META_DESCRIPTION =
  "Perceptica's media monitoring platform doubles as a media listening platform - alerts, dashboards, sentiment, exports and analyst review. Book a demo.";
